import React from 'react';
import { Filter, Clock, TrendingDown, AlertCircle, CheckCircle } from 'lucide-react';

const SectionTitle = ({ subtitle, title, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center' : ''}`}>
    <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <div className="w-12 h-0.5 bg-[#F49611]"></div>
      <span className="text-[#F49611] font-medium uppercase tracking-wider text-sm">{subtitle}</span>
    </div>
    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">{title}</h2>
  </div>
);

const WhyMatters = () => {
  const filters = [
    {
      icon: Filter,
      title: "Clarity",
      description: "Know exactly why you hold each investment",
      index: 1
    },
    {
      icon: Clock,
      title: "Confidence",
      description: "Stay invested with data-backed decisions",
      index: 2
    },
    {
      icon: TrendingDown,
      title: "Consistency",
      description: "Grow wealth with portfolios that adapt and evolve",
      index: 3
    }
  ];

  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <SectionTitle 
          subtitle="Ready to Experience"
          title="The Future of Wealth Management"
        />
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Why This Matters Section - Left Side */}
          <div>
            <p className="text-lg text-gray-600 mb-8">
            If you’re looking for a smarter way to invest—grounded in fundamentals, driven by data, and free of product-pushing—Maxiom Wealth’s portfolio management services (PMS) are built for you.

            </p>
            
            <p className="text-lg text-gray-600 mb-8">
            Talk to our team to explore how we can build a Roots & Wings portfolio tailored to your goals.

            </p>
            
            <div className="bg-white p-6 rounded-lg border-l-4 border-[#F49611] italic text-gray-700 font-medium mb-8">
            “Technology will not replace investment advisors. But those who use it will outperform those who don’t.”
            </div>
          </div>
          
          {/* Other Filters Section - Right Side */}
          <div className="bg-[#E8EEF6] rounded-2xl p-8 md:p-12">
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-[#113262] mb-6">Why It Matters for Investors</h3>
              <p className="text-gray-700 mb-6">
              Maxiom Wealth’s approach isn’t about chasing headlines. It’s about:
              </p>
              
              {filters.map((filter, index) => (
                <div key={index} className="flex items-start gap-4 mb-5">
                  <div className="w-6 h-6 rounded-full bg-[#F49611] flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <span className="font-medium text-[#113262]">{filter.title}:</span>
                    <span className="text-gray-700 ml-1">{filter.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyMatters;